import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import ScamAssistancePage from './components/pages/ScamAssistancePage';
import LiveTVPage from './components/pages/LiveTVPage';
import TypesOfScamsPage from './components/pages/TypesOfScamsPage';
import RomanceScamsPage from './components/pages/scams/RomanceScamsPage';
import PhishingSchemesPage from './components/pages/scams/PhishingSchemesPage';
import TechSupportScamsPage from './components/pages/scams/TechSupportScamsPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/scam-assistance" element={<ScamAssistancePage />} />
        <Route path="/live-tv" element={<LiveTVPage />} />
        <Route path="/types-of-scams" element={<TypesOfScamsPage />} />
        <Route path="/scams/romance-scams" element={<RomanceScamsPage />} />
        <Route path="/scams/phishing-schemes" element={<PhishingSchemesPage />} />
        <Route path="/scams/tech-support-scams" element={<TechSupportScamsPage />} />
      </Routes>
    </Router>
  );
}

export default App;